// CardContainer.jsx
import React from "react";

const CardContainer = ({ children, className = "" }) => {
  return (
    <div
      className={`rounded-2xl shadow-md border border-border p-6 ${className}`}
      style={{
        backgroundColor: "var(--surface)",
        color: "var(--text-body)",
      }}
    >
      {children}
    </div>
  );
};

export default CardContainer;
